export default "<m-video\n    src=\"https://public.mml.io/big-buck-bunny-10s-1mb.mp4\"\n    y=\"5\"\n    height=\"10\"\n    loop=\"true\"\n></m-video>\n";